export const navLinks = [
  { href: "#flash", label: "开箱速报" },
  { href: "#themes", label: "盲盒主题" },
  { href: "#tasting", label: "试吃清单" },
  { href: "#ranking", label: "惊喜榜单" },
  { href: "#flavor", label: "风味图鉴" },
  { href: "#faq", label: "盲盒小百科" },
];

export const footerLinks = [
  { href: "#picks", label: "本周精选开箱" },
  { href: "#flash", label: "开箱速报" },
  { href: "#themes", label: "盲盒主题分类" },
  { href: "#process", label: "开箱流程" },
  { href: "#tasting", label: "零食试吃清单" },
  { href: "#ranking", label: "惊喜指数榜单" },
  { href: "#flavor", label: "风味图鉴" },
  { href: "#faq", label: "盲盒小百科" },
];